<template>
  <a class="mr-2" @click="triggerAttribute">
    <slot>
      <a variant="default" size="small">
        <MIcon name="eye" class="cursor-pointer text-primary" />
      </a>
    </slot>
    <FlotoDrawer
      width="55%"
      :open="isDrawerOpen"
      class="flex"
      @hide="handleDrawerHide"
    >
      <template v-slot:title>
        {{ $tc('repair') }} {{ $tc('history') }}
      </template>
      <!-- <template v-slot:trigger>
        <span />
      </template> -->
      <MRow :gutter="0">
        <MCol :lg="12" :sm="12" auto-size>
          <MRow :gutter="0">
            <MCol :size="12" class="pl-2">
              <h5>{{ $tc('send_to_repair') }} {{ $tc('details', 2) }}</h5>
              <MDivider class="mt-0" />
            </MCol>
            <MCol :size="6" class="pl-2">
              <FlotoFormItemReadOnly :label="$tc('requester')">
                <FlotoRequesterPicker
                  :value="history.requesterId"
                  disabled
                  placeholder="---"
                />
              </FlotoFormItemReadOnly>
            </MCol>
            <MCol :size="6" class="pl-2">
              <FlotoFormItemReadOnly
                :label="`${$tc('reference')} ${$tc('number')}`"
              >
                {{ history.referenceNumber ? history.referenceNumber : '---' }}
              </FlotoFormItemReadOnly>
            </MCol>
            <MCol :size="6" class="pl-2">
              <FlotoFormItemReadOnly :label="$tc('vendor')">
                <td class="text-ellipsis">
                  <VendorPicker
                    disabled
                    :value="history.vendorId"
                    placeholder="---"
                    :as-input="false"
                  />
                </td>
              </FlotoFormItemReadOnly>
            </MCol>
            <MCol :size="6" class="pl-2">
              <FlotoFormItemReadOnly
                :label="`${$tc('vendor')} ${$tc('phone')}`"
              >
                {{ history.contectNo ? history.contectNo : '---' }}
              </FlotoFormItemReadOnly>
            </MCol>
            <MCol :size="6" class="pl-2">
              <FlotoFormItemReadOnly
                :label="`${$tc('vendor')} ${$tc('email')}`"
              >
                {{ history.vendorEmail ? history.vendorEmail : '---' }}
              </FlotoFormItemReadOnly>
            </MCol>
            <MCol :size="6" class="pl-2">
              <FlotoFormItemReadOnly :label="`${$tc('sent_date')}`">
                {{
                  !history.movementDate
                    ? '---'
                    : history.movementDate | datetime
                }}
              </FlotoFormItemReadOnly>
            </MCol>
            <MCol :size="6" class="pl-2">
              <FlotoFormItemReadOnly :label="`${$tc('expected_return_date')}`">
                {{
                  !history.expectedDate
                    ? '---'
                    : history.expectedDate | datetime
                }}
              </FlotoFormItemReadOnly>
            </MCol>
            <MCol :size="6" class="pl-2">
              <FlotoFormItemReadOnly :label="`${$tc('in_warranty')}`">
                {{ history.inWarranty === true ? $tc('yes') : $tc('no') }}
              </FlotoFormItemReadOnly>
            </MCol>
            <MCol :size="6" class="pl-2">
              <FlotoFormItemReadOnly :label="`${$tc('remark', 2)}`">
                {{ history.remarks ? history.remarks : '---' }}
              </FlotoFormItemReadOnly>
            </MCol>
            <MCol :size="6" class="pl-2">
              <FlotoFormItemReadOnly :label="`${$tc('out_movement_id')}`">
                <ResourceListTitle
                  :name="history.movementOutName"
                  :link="
                    $modules.getModuleRoute(
                      'asset-management',
                      'movement-view',
                      {
                        params: { id: history.movementOut },
                      }
                    )
                  "
                />
              </FlotoFormItemReadOnly>
            </MCol>
            <MCol :size="12" class="pl-2 mt-3">
              <h5>{{ $tc('return_from_repair') }} {{ $tc('details', 2) }}</h5>
              <MDivider class="mt-0" />
            </MCol>
            <MCol :size="6" class="pl-2">
              <FlotoFormItemReadOnly :label="`${$tc('return_date')}`">
                {{
                  !history.returnDate ? '---' : history.returnDate | datetime
                }}
              </FlotoFormItemReadOnly>
            </MCol>
            <MCol :size="6" class="pl-2">
              <FlotoFormItemReadOnly :label="`${__tc('fault')}`">
                {{ history.fault ? history.fault : '---' }}
              </FlotoFormItemReadOnly>
            </MCol>
            <MCol :size="6" class="pl-2">
              <FlotoFormItemReadOnly :label="`${$tc('repair_type')}`">
                <AssetMovementRepairTypePicker
                  :value="history.repairType"
                  placeholder="---"
                  disabled
                />
              </FlotoFormItemReadOnly>
            </MCol>
            <MCol :size="6" class="pl-2">
              <FlotoFormItemReadOnly :label="`${$tc('repair')} ${$tc('cost')}`">
                {{ history.repairCost >= 0 ? history.repairCost : '---' }}
              </FlotoFormItemReadOnly>
            </MCol>
            <MCol :size="6" class="pl-2">
              <FlotoFormItemReadOnly :label="`${$tc('solution')}`">
                {{ history.solution ? history.solution : '---' }}
              </FlotoFormItemReadOnly>
            </MCol>
            <MCol :size="6" class="pl-2">
              <FlotoFormItemReadOnly :label="`${$tc('warranty_covered')}`">
                {{ history.warrantyCovered ? $tc('yes') : $tc('no') }}
              </FlotoFormItemReadOnly>
            </MCol>
            <MCol :size="6" class="pl-2">
              <FlotoFormItemReadOnly :label="`${$tc('replaced')}`">
                {{ history.replaced ? $tc('yes') : $tc('no') }}
              </FlotoFormItemReadOnly>
            </MCol>
            <MCol :size="6" class="pl-2">
              <FlotoFormItemReadOnly :label="`${$tc('replaced_by')}`">
                <span v-if="history.replaceBy === 0">---</span>
                <span v-else>
                  <AssetPickerDrawer
                    v-if="history.replaceBy"
                    :value="history.replaceBy"
                    disabled
                    placeholder="---"
                    :as-input="false"
                    :module-name="history.refModel"
                    :fetch-fn="fetchAssetData"
                  />
                </span>
              </FlotoFormItemReadOnly>
            </MCol>
            <MCol :size="6" class="pl-2">
              <FlotoFormItemReadOnly :label="`${$tc('in_movement_id')}`">
                <ResourceListTitle
                  :name="history.movementInName"
                  :link="
                    $modules.getModuleRoute(
                      'asset-management',
                      'movement-view',
                      {
                        params: { id: history.movementIn },
                      }
                    )
                  "
                />
              </FlotoFormItemReadOnly>
            </MCol>
          </MRow>
        </MCol>
      </MRow>
      <template v-slot:actions="{ hide }">
        <MButton variant="default" @click="hide">
          {{ $tc('done') }}
        </MButton>
      </template>
    </FlotoDrawer>
  </a>
</template>
<script>
import AssetMovementRepairTypePicker from '@components/data-picker/asset-movement-repair-type-picker'
import AssetPickerDrawer from '@components/data-picker/asset-picker-drawer'
import { searchAssetsApi } from '@modules/asset/asset-api'
import ResourceListTitle from '@components/resource/resource-list-title'
import VendorPicker from '@components/data-picker/vendor-picker'
export default {
  name: 'RepairHistoryViewDrawer',
  components: {
    AssetMovementRepairTypePicker,
    VendorPicker,
    ResourceListTitle,
    AssetPickerDrawer,
  },
  props: {
    history: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      isDrawerOpen: false,
    }
  },
  methods: {
    fetchAssetData(moduleName, searchCriterias, limit, offset) {
      return searchAssetsApi(moduleName, searchCriterias, limit, offset)
    },
    handleDrawerHide() {
      this.isDrawerOpen = false
    },
    triggerAttribute() {
      this.$emit('trigger')
      setTimeout(() => {
        this.isDrawerOpen = true
      }, 400)
    },
  },
}
</script>
